interface MenuItem {
  id: number | string
  path?: string
  name: string
  icon: string
  iconSize: string
  subMenuItems?: {
    id: number | string
    path: string
    name: string
	  target: string
  }[]
}

const config: MenuItem[] = [
  {
    id: "home",
    path: '/',
    name: 'Home',
    icon: 'FaHome',
    iconSize: '1.4em',
  },
   {
    id: "links",
    name: 'Links',
    icon: 'FaLink',
    iconSize: '1.4em',
    subMenuItems: [
      {
        id: "levied_report",
        path: 'https://sbitest.sherlock.com.au/bnbguard/master-levied/levied_report.php',
        name: 'Levied Report',
		    target: '_blank',
      },
      {
        id: "master_converter",
        path: 'https://sbitest.sherlock.com.au/bnbguard/master-to-report-full/master_execute.php',
        name: 'Master Converter',
		    target: '_blank',
      },
        {
        id: "matching",
        path: 'https://sbitest.sherlock.com.au/bnbguard/master-match/master_match_execute.php',
        name: 'Matching',
		    target: '_blank',
      },
      {
        id: "report_processor",
        path: 'https://sbitest.sherlock.com.au/bnbguard/bnbguard_execute.php',
        name: 'Report Processor',
		    target: '_blank',
      },
    ],
  },
/*
  {
    id: "scraping",
    name: 'Scraping',
    icon: 'FaShoppingCart',
    iconSize: '1.35em',
    subMenuItems: [
      {
        id: "scraping_act",
        path: '/scraping/act',
        name: 'ACT',
 		    target: '_content',
     },
      {
        id: "scraping_nsw",
        path: '/scraping/nsw',
        name: 'NSW',
 		    target: '_content',
      },
      {
        id: "scraping_nt",
        path: '/scraping/nt',
        name: 'NT',
 		    target: '_content',
      },
      {
        id: "scraping_qld",
        path: '/scraping/qld',
        name: 'QLD',
 		    target: '_content',
      },
      {
        id: "scraping_sa",
        path: '/scraping/sa',
        name: 'SA',
 		    target: '_content',
      },
      {
        id: "scraping_tas",
        path: '/scraping/tas',
        name: 'TAS',
 		    target: '_content',
      },
      {
        id: "scraping_vic",
        path: '/scraping/vic',
        name: 'VIC',
 		    target: '_content',
      },
      {
        id: "scraping_wa",
        path: '/scraping/wa',
        name: 'WA',
 		    target: '_content',
      },
      {
        id: "scraping_buildings",
        path: '/scraping/buildings',
        name: 'Buildings',
 		    target: '_content',
      },
    ],
  },
  */
 /*
  {
    id: "scrape_history",
    path: '/history',
    name: 'Scrape History',
    icon: 'FaHistory',
    iconSize: '1.3em',
  },
  */
  /*
  {
    id: "councils",
    name: 'Councils',
    icon: 'FaBed',
    iconSize: '1.4em',
    subMenuItems: [
      {
        id: "councils_act",
        path: '/councils/act',
        name: 'ACT',
  		  target: '_content',
     },
      {
        id: "councils_nsw",
        path: '/councils/nsw',
        name: 'NSW',
  		target: '_content',
     },
      {
        id: "councils_nt",
        path: '/councils/nt',
        name: 'NT',
   		  target: '_content',
    },
      {
        id: "councils_qld",
        path: '/councils/qld',
        name: 'QLD',
 		    target: '_content',
      },
      {
        id: "councils_sa",
        path: '/councils/sa',
        name: 'SA',
   		  target: '_content',
    },
      {
        id: "councils_tas",
        path: '/councils/tas',
        name: 'TAS',
  		  target: '_content',
     },
      {
        id: "councils_vic",
        path: '/councils/vic',
        name: 'VIC',
  		  target: '_content',
     },
      {
        id: "councils_wa",
        path: '/councils/wa',
        name: 'WA',
 		    target: '_content',
      },
    ],
  },
  */
  {
    id: "scrapes",
    path: '/scrapes',
    name: 'Scrapes',
    icon: 'FaShoppingCart',
    iconSize: '1.35em',
  },
  {
    id: "bookings",
    path: '/bookings',
    name: 'Bookings',
    icon: 'FaCalendar',
    iconSize: '1.35em',
  },
  {
    id: "listings",
    path: '/listings',
    name: 'Listings',
    icon: 'FaBed',
    iconSize: '1.35em',
  },
  {
    id: "listings_websites",
    path: '/listings-websites',
    name: 'Listings (Websites)',
    icon: 'FaBed',
    iconSize: '1.35em',
  },
  {
    id: "brokenListings",
    path: '/broken-listings',
    name: 'Broken Listings',
    icon: 'FaBed',
    iconSize: '1.35em',
  },
  {
    id: "properties",
    path: '/properties',
    name: 'Properties',
    icon: 'FaBuilding',
    iconSize: '1.35em',
  },
  {
    id: "brokenProperties",
    path: '/broken-properties',
    name: 'Broken Properties',
    icon: 'FaBuilding',
    iconSize: '1.35em',
  },
  {
    id: "buildings",
    path: '/buildings',
    name: 'Buildings',
    icon: 'FaBuilding',
    iconSize: '1.35em',
  },
  {
    id: "assign_listings",
    path: '/assign-listings',
    name: 'Assign Listings',
    icon: 'FaEdit',
    iconSize: '1.4em',
   },
   {
    id: "assigned_listings",
    path: '/assigned-listings',
    name: 'Assigned Listings',
    icon: 'FaEdit',
    iconSize: '1.4em',
   },
   {
    id: "qa_listings",
    path: '/qa-listings',
    name: 'QA Listings',
    icon: 'FaEdit',
    iconSize: '1.4em',
   },
  /*
  {
    id: 28,
    name: 'Listings',
    icon: 'FaEdit',
    iconSize: '1.4em',
    subMenuItems: [
      {
        id: 29,
        path: '/councils-manage',
        name: 'Assign Properties',
  		target: '_content',
     },
      {
        id: 30,
        path: '/team-work',
        name: 'Assigned Work',
 		    target: '_content',
      },
      {
        id: 31,
        path: '/qa-work',
        name: 'QA List',
  		  target: '_content',
     },
      {
        id: 37,
        path: '/assign-listings',
        name: 'Assign Listings',
  		target: '_content',
     },
    ],
  },
  {
    id: 22,
    path: '/crons',
    name: 'Crons',
    icon: 'FaCalendarTimes',
    iconSize: '1.3em',
  },
  */
  {
    id: "list_users",
    icon: 'FaUser',
    iconSize: '1.3em',
	  path: '/list-users',
	  name: 'Users',
  },
  {
    id: "login_attempts",
    icon: 'FaUser',
    iconSize: '1.3em',
	  path: '/login-attempts',
	  name: 'Login Attempts',
  },
  /*
  {
    id: 24,
    name: 'Users',
    icon: 'FaUser',
    iconSize: '1.4em',
    subMenuItems: [
      {
        id: 25,
        path: '/profile',
        name: 'My Profile',
  	  	target: '_content',
     },
      {
        id: 26,
        path: '/register',
        name: 'Add User',
  	  	target: '_content',
     },
      {
        id: 27,
        path: '/list-users',
        name: 'List Users',
  	  	target: '_content',
     },
    ],
  },
  */
 ]

export default config
